import type { TellescopeFieldResponse } from "../../types";

/**
 * The state the booking page should be filtered to, from the enduser's own address answer.
 *
 * All three conditions matter. `intakeField === "Address"` is what distinguishes the enduser's own
 * address from a pharmacy's or an emergency contact's, and the truthy-`state` check is what lets the
 * first-match scan skip blank addresses left behind on unanswered conditional branches. A response
 * failing either is not a worse answer, it is a different question.
 */
export const getBookingAddressState = (responses: TellescopeFieldResponse[]): string | undefined =>
  responses.reduce<string | undefined>((found, r) => {
    if (found) return found;
    if (r.intakeField !== "Address") return found;
    if (r.answer?.type !== "Address") return found;
    return r.answer.value?.state || found;
  }, undefined);
